import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import { LanguageService } from '../../services/language.service';
import {FireApiService} from '../../services/fire-api.service';
import {UtilService} from '../../services/util.service';
import {BrainService} from '../../services/brain.service';

@Component({
  selector: 'app-review-ride',
  templateUrl: './review-ride.page.html',
  styleUrls: ['./review-ride.page.scss'],
})
export class ReviewRidePage implements OnInit {
  @Input() rideId: string;
  rating = 0;
  review = '';
  firstInteraction = false;

  constructor(
    public language: LanguageService,
    private modalCtrl: ModalController,
    private fireFunctions: FireApiService,
    private util: UtilService,
    private brain: BrainService
  ) { }

  ngOnInit() {
  }

  setRating(rate: number) {
    this.rating = rate;
    this.firstInteraction = true;
  }

  submit() {
    this.util.presentLoading(this.language.globalDictionary.submittingReview).then((loading) => {
      this.fireFunctions.submitReview(this.rideId, this.rating, this.review).then(async () => {
        await loading.dismiss();
        if (this.brain.lastCompletedRide?.id === this.rideId) {
          this.brain.lastCompletedRide = null;
        }
        this.modalCtrl.dismiss();
      });
    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
